<template>
  <div class="d-flex align-items-center flex-column justify-content-between bgBenefitBox p-2 card">
    <div style="" class="bgBenefitBoxImg p-2">
      <b-img :src="require(`@/assets/images/new-images-fx/${info.img}`)" fluid />
    </div>
    <div class="my-1">
      <h3 class="font-weight-bold mb-0">{{ info.title }}</h3>
    </div>
    <div class="text-center mb-2 ">
      <span>{{ info.description }}</span>
    </div>
  </div>
</template>

<script>
import { BImg } from "bootstrap-vue";
export default {
  components: {
    BImg,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.bgBenefitBox{
  background: #1B1B24 ;  
}
.bgBenefitBoxImg{
 background: transparent linear-gradient(160deg, #282833 0%, #15182508 100%)  ;
 border-radius: 42px;
 width: 80px 
}
</style>></style>
